var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTroubleshooting31Fc5290(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 56,
    viewBox: "0 0 50 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3631 55.8798H0.769531C0.769531 43.9797 11.6127 34.2432 24.8655 34.2432C38.5199 34.2432 49.3631 43.9797 49.3631 55.8798Z",
    fill: "#252117"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8672 5.75389C30.8912 5.75389 36.112 10.0812 36.112 15.851C36.112 21.2602 31.2928 25.9481 24.8672 25.9481C18.4416 25.9481 14.024 21.2602 14.024 15.851C14.024 10.0812 18.8432 5.75389 24.8672 5.75389ZM24.8672 0.344727C15.6304 0.344727 8 7.19633 8 15.851C8 24.5057 15.6304 31.3573 25.2688 31.3573C34.9072 31.3573 42.5376 24.5057 42.5376 15.851C42.136 7.19633 34.5056 0.344727 24.8672 0.344727Z",
    fill: "#252117"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTroubleshooting31Fc5290);
export default __webpack_public_path__ + "static/media/troubleshooting.31fc5290.06b8f8857b7ef0411c816e50eb99ec74.svg";
export { ForwardRef as ReactComponent };